module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f9d0.ece62835.svg";